import { render, staticRenderFns } from "./iam-view-toolbar.vue?vue&type=template&id=af9b6c64&"
import script from "./iam-view-toolbar.vue?vue&type=script&lang=js&"
export * from "./iam-view-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports